import { render, staticRenderFns } from "./ximei_settlement.vue?vue&type=template&id=a614b5ae&scoped=true&"
import script from "./ximei_settlement.vue?vue&type=script&lang=js&"
export * from "./ximei_settlement.vue?vue&type=script&lang=js&"
import style0 from "./ximei_settlement.vue?vue&type=style&index=0&id=a614b5ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a614b5ae",
  null
  
)

export default component.exports